export class MachineFilters {
  alias: string;
  serialNumber: string;
  eui: string;
  simNumber: string;
  isOn: boolean;
  isPoweredOn: boolean;
  organizationUuids: string[];
  machineModelUuids: string[];
  countries: string[];
  states: string[];
  localities: string[];
  from: number;
  until: number;
  deleted: boolean;
  machineGroupsUuids: string[];
  alarmsDefinitionUuids: string[];
  communicationType: number;
}
